export const RoleProhibit = 'prohibit';

export const StressCheckRoleOptions = [
  { label: '権限なし', value: RoleProhibit },
  { label: '実施者', value: 'stress_check_practitioner' },
  { label: '実務担当者', value: 'stress_check_person_in_charge' }
];

export const HealthCheckRoleOptions = [
  { label: '権限なし', value: RoleProhibit },
  { label: '権限あり', value: 'regular_health_checkup_user' }
];

export const UserManageRoleOptions = [
  { label: '権限なし', value: RoleProhibit },
  { label: '権限あり', value: 'user_manager' }
];
